/**
 * Custom CORE syntax highlighting theme
 * Based on VS2015 dark theme
 */

export const coreThemeDark: Record<string, React.CSSProperties> = {
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "padding": "0.5em",
    "background": "var(--core-layer-base)",
    "color": "#DCDCDC"
  },
  "hljs-keyword": {
    "color": "#569CD6"
  },
  "hljs-literal": {
    "color": "#569CD6"
  },
  "hljs-symbol": {
    "color": "#569CD6"
  },
  "hljs-name": {
    "color": "#569CD6"
  },
  "hljs-link": {
    "color": "#569CD6",
    "textDecoration": "underline"
  },
  "hljs-built_in": {
    "color": "#4EC9B0"
  },
  "hljs-type": {
    "color": "#4EC9B0"
  },
  "hljs-number": {
    "color": "#B5CEA8"
  },
  "hljs-class": {
    "color": "#B8D7A3"
  },
  "hljs-string": {
    "color": "#D69D85"
  },
  "hljs-meta-string": {
    "color": "#D69D85"
  },
  "hljs-regexp": {
    "color": "#D69D85"
  },
  "hljs-template-tag": {
    "color": "#D69D85"
  },
  "hljs-subst": {
    "color": "#DCDCDC"
  },
  "hljs-function": {
    "color": "#DCDCDC"
  },
  "hljs-title": {
    "color": "#DCDCDC"
  },
  "hljs-params": {
    "color": "#DCDCDC"
  },
  "hljs-formula": {
    "color": "#DCDCDC"
  },
  "hljs-comment": {
    "color": "#BEFDB2",
    "fontStyle": "italic"
  },
  "hljs-quote": {
    "color": "#BEFDB2",
    "fontStyle": "italic"
  },
  "hljs-doctag": {
    "color": "#BEFDB2"
  },
  "hljs-meta": {
    "color": "#9B9B9B"
  },
  "hljs-meta-keyword": {
    "color": "#9B9B9B"
  },
  "hljs-tag": {
    "color": "#9B9B9B"
  },
  "hljs-variable": {
    "color": "#BD63C5"
  },
  "hljs-template-variable": {
    "color": "#BD63C5"
  },
  "hljs-attr": {
    "color": "#9CDCFE"
  },
  "hljs-attribute": {
    "color": "#9CDCFE"
  },
  "hljs-builtin-name": {
    "color": "#9CDCFE"
  },
  "hljs-section": {
    "color": "gold"
  },
  "hljs-emphasis": {
    "fontStyle": "italic"
  },
  "hljs-strong": {
    "fontWeight": "bold"
  },
  "hljs-bullet": {
    "color": "#D7BA7D"
  },
  "hljs-selector-tag": {
    "color": "#D7BA7D"
  },
  "hljs-selector-id": {
    "color": "#D7BA7D"
  },
  "hljs-selector-class": {
    "color": "#D7BA7D"
  },
  "hljs-selector-attr": {
    "color": "#D7BA7D"
  },
  "hljs-selector-pseudo": {
    "color": "#D7BA7D"
  },
  "hljs-addition": {
    "backgroundColor": "#144212",
    "display": "inline-block",
    "width": "100%"
  },
  "hljs-deletion": {
    "backgroundColor": "#600",
    "display": "inline-block",
    "width": "100%"
  }
};

export const coreThemeLight: Record<string, React.CSSProperties> = {
  "hljs": {
    "display": "block",
    "overflowX": "auto",
    "padding": "0.5em",
    "background": "var(--core-layer-base)",
    "color": "#333"
  },
  "hljs-comment": {
    "color": "#008000",
    "fontStyle": "italic"
  },
  "hljs-quote": {
    "color": "#008000",
    "fontStyle": "italic"
  },
  "hljs-keyword": {
    "color": "#0000FF",
    "fontWeight": "bold"
  },
  "hljs-selector-tag": {
    "color": "#800000",
    "fontWeight": "bold"
  },
  "hljs-subst": {
    "color": "#333",
    "fontWeight": "normal"
  },
  "hljs-number": {
    "color": "#098658"
  },
  "hljs-literal": {
    "color": "#0000FF"
  },
  "hljs-variable": {
    "color": "#001080"
  },
  "hljs-template-variable": {
    "color": "#001080"
  },
  "hljs-tag .hljs-attr": {
    "color": "#FF0000"
  },
  "hljs-string": {
    "color": "#A31515"
  },
  "hljs-doctag": {
    "color": "#008000"
  },
  "hljs-title": {
    "color": "#795E26",
    "fontWeight": "bold"
  },
  "hljs-section": {
    "color": "#795E26",
    "fontWeight": "bold"
  },
  "hljs-selector-id": {
    "color": "#800000",
    "fontWeight": "bold"
  },
  "hljs-type": {
    "color": "#267F99",
    "fontWeight": "bold"
  },
  "hljs-class .hljs-title": {
    "color": "#267F99",
    "fontWeight": "bold"
  },
  "hljs-tag": {
    "color": "#800000",
    "fontWeight": "normal"
  },
  "hljs-name": {
    "color": "#800000",
    "fontWeight": "normal"
  },
  "hljs-attribute": {
    "color": "#FF0000",
    "fontWeight": "normal"
  },
  "hljs-regexp": {
    "color": "#811F3F"
  },
  "hljs-link": {
    "color": "#0000FF"
  },
  "hljs-symbol": {
    "color": "#0000FF"
  },
  "hljs-bullet": {
    "color": "#800000"
  },
  "hljs-built_in": {
    "color": "#267F99"
  },
  "hljs-builtin-name": {
    "color": "#267F99"
  },
  "hljs-meta": {
    "color": "#808080"
  },
  "hljs-meta-keyword": {
    "color": "#0000FF"
  },
  "hljs-meta-string": {
    "color": "#A31515"
  },
  "hljs-emphasis": {
    "fontStyle": "italic"
  },
  "hljs-strong": {
    "fontWeight": "bold"
  },
  "hljs-function": {
    "color": "#795E26"
  },
  "hljs-params": {
    "color": "#333"
  },
  "hljs-attr": {
    "color": "#FF0000"
  },
  "hljs-addition": {
    "backgroundColor": "rgba(155, 185, 85, 0.2)",
    "display": "inline-block",
    "width": "100%"
  },
  "hljs-deletion": {
    "backgroundColor": "rgba(255, 0, 0, 0.2)",
    "display": "inline-block",
    "width": "100%"
  }
};
